import { useAtom } from 'jotai'
import { AdvanceComp } from '../ai-form/AdvanceComp'
import { CharacterComp } from '../ai-form/CharacterComp'
import { MjParamsComp } from '../ai-form/MjParamsComp'
import { ModelFusionComp } from '../ai-form/ModelFusionComp'
import { ModelSelectComp } from '../ai-form/ModelSelectComp'
import { ModelThemeComp } from '../ai-form/ModelThemeComp'
import { NormalInitImageComp } from '../ai-form/NormalInitImageComp'
import { PictureResolutionComp } from '../ai-form/PictureResolutionComp'
import { PictureSizeComp } from '../ai-form/PictureSizeComp'
import { PromptComp } from '../ai-form/PromptComp'
import { StyleDecorationComp } from '../ai-form/StyleDecorationComp'
import { StyleModelComp } from '../ai-form/StyleModelComp'
import { UcPropmtComp } from '../ai-form/UcPropmtComp'
import { VipParamsComp } from '../ai-form/VipParamsComp'
import { hasAdvanceAtom } from '../ai-form/atom'
import { useType } from '../useType'
import ReferToGroup from '../ai-form/ReferToGroup'
import useOptions from '../ai-form/useOptions'

export const NormalFormContent = () => {
  /** 高级选项 */
  const [hasAdvance] = useAtom(hasAdvanceAtom)

  const { isMJ, isST, is4k } = useType()
  const { isFlux } = useOptions()

  return (
    <>
      {/** dd sd ad选择 */}
      <ModelSelectComp />

      {/* 画面描述 */}
      <PromptComp />

      {/* 画面大小和尺寸 */}
      <PictureSizeComp />
      <PictureResolutionComp />

      {/* 模型主题 */}
      {!isST && <ModelThemeComp />}

      {/* 风格模型 */}
      {isST && <StyleModelComp />}

      {/** 标签选择 */}
      {!isST && <StyleDecorationComp />}

      {/** 高级设置 */}
      {!isST && <AdvanceComp />}

      {hasAdvance && !isST && (
        <>
          {/** 底图 */}
          {!is4k && <NormalInitImageComp />}

          {/* 风格参考、角色参考、结构参考 */}
          {!is4k && !isFlux && <ReferToGroup />}

          {/* 负面描述 */}
          {!isFlux && <UcPropmtComp />}

          {/** 角色同人 */}
          <CharacterComp />

          {/** 融合模型 */}
          <ModelFusionComp />

          {/* 会员专享参数 */}
          {!isMJ && <VipParamsComp />}

          {/* MJ/NJ 特别参数 */}
          {isMJ && <MjParamsComp />}
        </>
      )}
    </>
  )
}
